//INIT GAME AND CANVAS
const game = new ex.Engine({
  width: 320,
  height: 288,
  backgroundColor: ex.Color.fromHex("#ffffff"),
  pixelArt: true,
  pointerScope: ex.Input.PointerScope.Document,
  canvasElementId: "gameOne", // the DOM canvas element ID, if you are providing your own
});

//MISC CONSTANTS
const ANCHOR_CENTER = new ex.Vector(0.5, 0.5);
const ANCHOR_TOP_LEFT = new ex.Vector(0, 0);
const WALK_VELOCITY = 120;
const FALL_VELOCITY = 10;
const ONI_ROAM_VELOCITY = 20;
const ONI_RETURN_VELOCITY = 60;
const ONI_CHARGE_VELOCITY = 150;
const CHARGE_RADIUS = 65;
const LEFT = "LEFT";
const RIGHT = "RIGHT";
const UP = "UP";
const DOWN = "DOWN";
const WALK = "WALK";
const PUSHER = "PUSHER";
const CHARGEABLE = "CHARGEABLE";
const camera = game.currentScene.camera;
const keyboard = game.input.keyboard;
const touch = game.input.pointers.primary;
const loaderCover = document.getElementById("loaderCover");
const loaderProgress = document.getElementById("loaderProgress");
const customerId = document.getElementById("gameOne").getAttribute("data-customerId");
const discountCode = "H50-"+Math.random().toString(36).substring(2, 8).toUpperCase();
const discountStart = new Date().toISOString();
const discountEnd = new Date();
discountEnd.setDate(discountEnd.getDate() + 30);
const discountEndISO = discountEnd.toISOString();
const discountCollection = "291518021811";
var gameTimer;
var gameTime = 0;
// SOUNDS
const hariLand = new ex.Sound("https://cdn.shopify.com/s/files/1/0440/5444/6233/files/HARI_LAND.wav?v=1732414332");

// DPAD & MOBILE BUTTON INPUT
const dPadUp = document.getElementById("dPadUp");
const dPadRight = document.getElementById("dPadRight");
const dPadLeft = document.getElementById("dPadLeft");
const dPadDown = document.getElementById("dPadDown");
const aButton = document.getElementById("aButton");
const bButton = document.getElementById("bButton");
var dPadUpHeld = false;
var dPadRightHeld = false;
var dPadDownHeld = false;
var dPadLeftHeld = false;
var aButtonPressed = false;
var bButtonPressed = false;

touch.on('down', function (evt) {
  dPadUpHeld = evt.nativeEvent.target == dPadUp;
  dPadRightHeld = evt.nativeEvent.target == dPadRight;
  dPadDownHeld = evt.nativeEvent.target == dPadDown;
  dPadLeftHeld = evt.nativeEvent.target == dPadLeft;
  aButtonPressed = evt.nativeEvent.target == aButton;
  bButtonPressed = evt.nativeEvent.target == bButton;
});

touch.on('up', function (evt) {
  dPadUpHeld = false;
  dPadRightHeld = false;
  dPadDownHeld = false;
  dPadLeftHeld = false;
  aButtonPressed = false;
});

//IMAGES AND ANIMATIONS
const Images = {
  hariSheetImage: new ex.ImageSource(
    "https://cdn.shopify.com/s/files/1/0440/5444/6233/t/3/assets/hari-spritesheet.png?v=1730669668"
  ),
  oniSheetImage: new ex.ImageSource(
    "https://cdn.shopify.com/s/files/1/0440/5444/6233/t/3/assets/floblin1.png?v=1730508023"
  ),
  mapImage: new ex.ImageSource(
    "https://cdn.shopify.com/s/files/1/0440/5444/6233/t/3/assets/map1-terrain.png?v=1732402973"
  ),
  bgImage: new ex.ImageSource(
    "https://cdn.shopify.com/s/files/1/0440/5444/6233/t/3/assets/map1-bg.png?v=1731000041"
  ),
  computerImage: new ex.ImageSource(
    "https://cdn.shopify.com/s/files/1/0440/5444/6233/t/3/assets/computer.png?v=1730752358"
  ),
  dialogBoxImage: new ex.ImageSource(
    "https://cdn.shopify.com/s/files/1/0440/5444/6233/t/3/assets/dailogBox.png?v=1730755793"
  ),
  fontSheetImage: new ex.ImageSource(
    "https://cdn.shopify.com/s/files/1/0440/5444/6233/t/3/assets/fontsheet.png?v=1730759928"
  ),
  floppySheetImage: new ex.ImageSource(
    "https://cdn.shopify.com/s/files/1/0440/5444/6233/t/3/assets/floppyDisk.png?v=1730998728",
  ),
};

// LOAD ASSETS
class MyLoader extends ex.DefaultLoader {
  onBeforeLoad() {
  }
  onDraw() {
  }
  onAfterLoad(){
  }
}

const loader = new MyLoader();
loader.suppressPlayButton = true;
const loaderMinTime = 1500;
var loaderElapsedTime = 0
const loaderTimer = setInterval(()=>{
  loaderElapsedTime+=100;
  loaderProgress.style.width = (((loaderElapsedTime/loaderMinTime)*50)+(loader.progress*50))+"%";
  if (loaderElapsedTime >= loaderMinTime && loader.isLoaded) {
      
    setTimeout(()=>{
      clearInterval(loaderTimer);
      loaderCover.remove();
      if (!gameTimer) gameTimer = setInterval(()=>{gameTime+=100;},100);
      hari.enterScene();
    },1000);
    
  }
;},100);

const allResources = { ...Images, hariLand };
for (const res in allResources) {
  loader.addResource(allResources[res]);
}
const hariSpriteSheet = ex.SpriteSheet.fromImageSource({
  image: Images.hariSheetImage,
  grid: {
    columns: 3,
    rows: 6,
    spriteWidth: 32,
    spriteHeight: 32,
  },
});

const oniSpriteSheet = ex.SpriteSheet.fromImageSource({
  image: Images.oniSheetImage,
  grid: {
    columns: 2,
    rows: 2,
    spriteWidth: 32,
    spriteHeight: 32,
  },
});
const floppySpriteSheet = ex.SpriteSheet.fromImageSource({
  image: Images.floppySheetImage,
  grid: {
    columns: 2,
    rows: 2,
    spriteWidth: 32,
    spriteHeight: 32,
  },
});

const fontSheet = ex.SpriteSheet.fromImageSource({
  image: Images.fontSheetImage,
  grid: {
    columns: 16,
    rows: 5,
    spriteWidth: 16,
    spriteHeight: 16,
  },
});
const spriteFont = new ex.SpriteFont({
    alphabet: "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789?!.():;[]&./,-' ",
    caseInsensitive: false,
    spriteSheet: fontSheet,
    lineHeight: 24
  });


const idleDown = ex.Animation.fromSpriteSheet(hariSpriteSheet, [1], 200);
const idleUp = ex.Animation.fromSpriteSheet(hariSpriteSheet, [4], 200);
const idleRight = ex.Animation.fromSpriteSheet(hariSpriteSheet, [7], 200);
const idleLeft = ex.Animation.fromSpriteSheet(hariSpriteSheet, [10], 200);
const walkDown = ex.Animation.fromSpriteSheet(hariSpriteSheet, [0,2], 200);
const walkUp = ex.Animation.fromSpriteSheet(hariSpriteSheet, [3,5], 200);
const walkRight = ex.Animation.fromSpriteSheet(hariSpriteSheet, [6,7,8,7], 200);
const walkLeft = ex.Animation.fromSpriteSheet(hariSpriteSheet, [9,10,11,10], 200);
const fallDown = ex.Animation.fromSpriteSheet(hariSpriteSheet, [12,13,14], 300, ex.AnimationStrategy.End);
const holdUp = ex.Animation.fromSpriteSheet(hariSpriteSheet, [15,16], 300);
const hariRotate = ex.Animation.fromSpriteSheet(hariSpriteSheet, [1,10,4,7], 200);

const floppyIdle = ex.Animation.fromSpriteSheet(floppySpriteSheet, [0], 200);
const floppyRotate = ex.Animation.fromSpriteSheet(floppySpriteSheet, [0,1,2,3], 500);

const oniFlyLeft = ex.Animation.fromSpriteSheet(oniSpriteSheet, [0,1], 100);
const oniChargeLeft = ex.Animation.fromSpriteSheet(oniSpriteSheet, [2,3], 100);
oniChargeLeft.flipHorizontal = true;

//BUILD ONI
class Oni extends ex.Actor {
  constructor(x, y) {
    super({
      x: x,
      y: y,
      width: 32,
      height: 32,
      collider: ex.Shape.Box(16, 16, ANCHOR_CENTER, new ex.Vector(0, 0)),
      collisionType: ex.CollisionType.Active,
      color: ex.Color.fromHex("#222222"),
    });
    this.graphics.use(oniFlyLeft);
    this.isRoaming = false;
    this.isCharging = false;
    this.spawnPoint = new ex.Vector(this.pos.x,this.pos.y);
    this.on("postcollision", (evt) => this.onPostCollision(evt));
  }
  onPreUpdate(engine, delta) {
    !this.isReturning ? this.checkForHari() : null
  }
  onInitiliaze(engine) {
    this.addTag(PUSHER);
  };

  roam() {
    if (!this.isRoaming){
        this.roamStart = this.pos.x;
        this.roamEnd = this.roamStart + 70;
        this.yStart = this.pos.y;
        this.yEnd = this.pos.y+5;
        this.isRoaming = true;
        this.isReturning = false;
    }
    if (this.pos.y <= this.yStart) this.vel.y = 6;
    if (this.pos.y >= this.yEnd) this.vel.y = -6;
    if (this.pos.x <= this.roamStart) {
      this.vel.x = ONI_ROAM_VELOCITY
      oniFlyLeft.flipHorizontal = true;
    } 
    if (this.pos.x >= this.roamEnd) {
      this.vel.x = -ONI_ROAM_VELOCITY
      oniFlyLeft.flipHorizontal = false;
    }
  }

  checkForHari() {
    const hariEntities = game.currentScene.world.queryTags([CHARGEABLE]).getEntities();
    if (hariEntities.length && !this.isReturning) {
      var target = hariEntities[0];
      var distance = target.pos.distance(this.pos);
      if (distance < CHARGE_RADIUS && !this.isCharging) {
        this.isCharging = true;
        this.charge(target);
        setTimeout(()=>{this.isCharging=false},50);
      } else {
        this.roam();
        this.isRoaming = true;
        this.isCharging = false;
      } 
    }
  }

  charge(target) {
    this.isRoaming = false;
    const dest = target.pos;
    const distance = target.pos.distance(this.pos);
    if (!target.isFalling && !target.isSafe){
          this.graphics.use(oniChargeLeft);
          if (this.pos.x + 2 < dest.x) {
            oniFlyLeft.flipHorizontal = true;
            this.vel.x = ONI_CHARGE_VELOCITY;
          }
          if (this.pos.x - 2 > dest.x) {
            oniFlyLeft.flipHorizontal = false;
            this.vel.x = -ONI_CHARGE_VELOCITY;
          }
          if (this.pos.y + 2 < dest.y) {
            this.vel.y = ONI_CHARGE_VELOCITY;
          }
          if (this.pos.y - 2 > dest.y) {
            this.vel.y = -ONI_CHARGE_VELOCITY;
          }
    } else {
      this.endCharge();
      
    }
  }

  endCharge() {
    this.vel.x = 0;
    this.vel.y = 0;
    this.isReturning = true;
    this.graphics.use(oniFlyLeft);
    this.actions.moveTo(this.spawnPoint,ONI_RETURN_VELOCITY).toPromise().then(()=>{
      this.roam();
      this.isCharging = false;
    });
    
  }

  onPostCollision(evt){
    
  }
  
};
  
//BUILD HARI
class Hari extends ex.Actor {
  constructor(x, y) {
    super({
      x: x,
      y: y,
      width: 32,
      height: 32,
      collider: ex.Shape.Box(12, 16, ANCHOR_CENTER, new ex.Vector(0, 8)),
      collisionType: ex.CollisionType.Active,
      color: ex.Color.fromHex("#222222"),
    });
    this.pushState = null;
    this.isFrozen = false;
    this.graphics.use(idleDown);
    this.idleDir = idleDown;
    this.isSafe = false;
    this.on("precollision", (evt) => this.onPreCollision(evt));
    this.on("postcollision", (evt) => this.onPostCollision(evt));
    this.on("collisionend", (evt) => this.onCollisionEnd(evt));
  }

  onInitialize(engine){
    this.addTag(CHARGEABLE);
    this.addTag("HARI");
  }
  //PHYSICS AND ANIMATIONS
  onPreCollision(evt) {
    if (evt.other.hasTag("SAFEZONE") && evt.other.owner !== this) {
      this.isSafe = true;
    }
  };
  onCollisionEnd(evt) {
    if (evt.other && evt.other.hasTag("SAFEZONE") && evt.other.owner !== this) {
      this.isSafe = false;
    }
  }
  onPostCollision(evt) {
    if (evt.other.hasTag(PUSHER) && evt.other.owner !== this) {
      var pusher = evt.other.owner;
      this.pushState = {
        pushVelX: pusher.vel.x > 0 ? ONI_CHARGE_VELOCITY : -ONI_CHARGE_VELOCITY,
        pushVelY: pusher.vel.y > 0 ? ONI_CHARGE_VELOCITY : -ONI_CHARGE_VELOCITY,
      };
    }
  }
  onPreUpdate(engine, delta) {
    this.onPreUpdateMovement(engine, delta);
    this.onPreUpdateAnimationLoop(engine, delta);
    this.checkCameraPosition();
  }
  onPreUpdateMovement(engine, delta) {
    if (!this.isFalling && !this.isFrozen) {
      this.vel.x = 0;
      this.vel.y = 0;
      if (keyboard.isHeld(ex.Input.Keys.Left) || dPadLeftHeld) {
        this.vel.x = -WALK_VELOCITY;
      }
      if (keyboard.isHeld(ex.Input.Keys.Right) || dPadRightHeld) {
        this.vel.x = WALK_VELOCITY;
      }
      if (keyboard.isHeld(ex.Input.Keys.Up) || dPadUpHeld) {
        this.vel.y = -WALK_VELOCITY;
      }
      if (keyboard.isHeld(ex.Input.Keys.Down) || dPadDownHeld) {
        this.vel.y = WALK_VELOCITY;
      }
      if (this.pushState) {
        this.vel.x = this.pushState.pushVelX;
        this.vel.y = this.pushState.pushVelY;
        return;
      }
    };
  }
  onPreUpdateAnimationLoop(engine, delta) {
      if (this.isFrozen){
      } else{
        this.graphics.use(this.idleDir);
        if (!this.isFalling) {
            if (keyboard.isHeld(ex.Input.Keys.Left) || dPadLeftHeld) {
              this.graphics.use(walkLeft);
              this.idleDir = idleLeft;
            }
            if (keyboard.isHeld(ex.Input.Keys.Right) || dPadRightHeld) {
              this.graphics.use(walkRight);
              this.idleDir = idleRight;
            }
            if (keyboard.isHeld(ex.Input.Keys.Up) || dPadUpHeld) {
              this.graphics.use(walkUp);
              this.idleDir = idleUp;
            }
            if (keyboard.isHeld(ex.Input.Keys.Down) || dPadDownHeld) {
              this.graphics.use(walkDown);
              this.idleDir = idleDown;
            }
        } else {
          this.graphics.use(fallDown);
        }
      };
  }
  checkCameraPosition() {
    const xTrigger = 320;
    const yTrigger = 288;

    var hariX = this.pos.x,
        hariY = this.pos.y,
        cameraX = camera.x,
        cameraY = camera.y;

    Math.sign(hariX - xTrigger) > 0 ? camera.x = 480 : camera.x = 160
    Math.sign(hariY - yTrigger) > 0 ? camera.y = 432 : camera.y = 144
  }
  
  fall(evt) {
    this.pushState = null;
    this.isFalling = true;
    var spawnPos = new ex.Vector(336,144),
        mtvX = evt.contact.mtv.x,
        mtvY = evt.contact.mtv.y;
    if (this.pos.x < 320 && this.pos.y < 288) spawnPos = new ex.Vector(120,120); //q1
    //maintain velocity
    //this.vel.y = Math.sign(this.vel.y)*FALL_VELOCITY;
    //this.vel.x = ;
    this.vel.x > 0 ? this.pos.x += 12 : null
    this.vel.x < 0 ? this.pos.x -= 12 : null
    this.vel.x = Math.sign(this.vel.x)*FALL_VELOCITY
    this.vel.y < 0 ? this.pos.y += 2 : null
    this.vel.y > 0 ? this.pos.y += 24 : null
    this.vel.y = Math.sign(this.vel.y)*FALL_VELOCITY
    //move position further into collider
    this.pos.x += mtvX;
    this.pos.y += mtvY;
    //after first frame, lower behind map z
    setTimeout(()=>{this.z = 0},200);
    //back to spawn
    this.actions.delay(1500).toPromise().then(()=>{
      this.actions.blink(50, 50, 4);
      this.pos.x = spawnPos.x;
      this.pos.y = spawnPos.y;
      this.isFalling = false;
      this.graphics.use(idleDown);
      fallDown.reset();
      this.z = 3;
    });
  }
  enterScene(){
    this.actions.moveTo(new ex.Vector(120,120),500).callMethod(()=> { 
      this.hasEntered=true;
      this.isFrozen=false;
      hariLand.play(1);
      game.add(new Block(0,0,256,16));
    });
  }
};
//computer test spawn
//const hari = new Hari(480,440);
//play spawn
const hari = new Hari(120, -120);
const feet = new ex.Actor({
  width: 8,
  height: 2,
  pos: new ex.Vector(0,14),
  //color: ex.Color.White,
});
hari.addChild(feet);
feet.on('precollision', (evt) => {
  if (evt.other.hasTag("ABYSS") && !hari.isFalling) {
    Math.abs(evt.contact.mtv.x) >= 1 || Math.abs(evt.contact.mtv.y) >= 1 ? hari.fall(evt) : null
  };
});
const floppy = new ex.Actor({
  width: 32,
  height: 32,
  pos: new ex.Vector(0,-32),
  color: ex.Color.White,
  z: 3,
});
floppy.graphics.use(floppyIdle);
floppy.graphics.opacity = 0;
hari.addChild(floppy);


//BUILD COMPONENTS: COMPUTER + TEXT + HEART

const computerSprite = Images.computerImage.toSprite();
class Computer extends ex.Actor {
  constructor(x, y, w, h) {
    super({
      width: 32,
      height: 64,
      pos: new ex.Vector(x,y),
      anchor: ANCHOR_TOP_LEFT,
      collider: ex.Shape.Box(34,64, ANCHOR_TOP_LEFT, new ex.Vector(0, 0)),
      collisionType: ex.CollisionType.Fixed,
      color: ex.Color.White,
    });
    this.graphics.use(computerSprite);
  }
}
const computer = new Computer(496,416);
const readArea = new ex.Actor({
  width: 32,
  height: 12,
  anchor: ANCHOR_TOP_LEFT,
  pos: new ex.Vector(0,64),
});
computer.addChild(readArea);

const dialogBox = new ex.Actor({
  width:320,
  height:72,
  anchor: ANCHOR_TOP_LEFT,
  pos: new ex.Vector(320,288+216),
});
const dialogBoxSprite = Images.dialogBoxImage.toSprite();
dialogBox.graphics.use(dialogBoxSprite);
dialogBox.graphics.opacity = 0;

const textLines = [
  "Welcome...",
  "Ejecting disk...",
  "YOU RECEIVED DISK ONE!!",
  "More adventures await...",
  "For now, here's a reward...",
]
textLines.forEach((line,index) => {
  //if the 17th character is a letter, put a line break at the start of that word
  if (line[16] && line[16]!=" ") {
    let closestSpaceIndex = line.lastIndexOf(' ', 16);
    if (closestSpaceIndex !== -1) textLines[index] = line.slice(0, closestSpaceIndex) + '\n' + line.slice(closestSpaceIndex + 1);
  }
});
console.log(textLines);
if (!customerId) {
  textLines.push("You must sign in first to save this disk...");
  textLines.push("Let me take you...");
};
const revealIndex = 3;
const dialogArray = []
var textIndex = 0;
textLines.forEach((line) => {
      dialogArray.push(new ex.Text({
        text: line,
        font: spriteFont,
        height: 16,
        lineHeight: 32,
        maxWidth:272,
    }));
});

const dialog = new ex.Actor({
    width:300,
    height:48,
    anchor: ANCHOR_TOP_LEFT,
    color: ex.Color.Red,
    pos: ex.vec(16, 16),
    z: 5,
});
dialog.graphics.opacity = 0;
dialog.graphics.use(dialogArray[0]);
dialogBox.addChild(dialog);
let lastText = "";  
readArea.on('precollision', (evt) => {

  if (evt.other.hasTag("HARI") && (keyboard.wasPressed(ex.Input.Keys.Space) || aButtonPressed )) {
    clearInterval(gameTimer);
    hari.isFrozen = true;
    if (textIndex < textLines.length) {
        dialogBox.graphics.opacity = 1;
        dialog.graphics.opacity = 1;
        dialog.graphics.use(dialogArray[textIndex]);
        lastText = dialogArray[textIndex].text;
        textIndex += 1
        if (textIndex == revealIndex){
          hari.graphics.use(holdUp);
          floppy.graphics.opacity = 1;
          setTimeout(()=>{floppy.graphics.use(floppyRotate)},1000);
        }
    } else {
      console.log(lastText)
      exitSeq(lastText);
      if (customerId && customerId != ""){
        updateCustomerMetafields(customerId,'customer','game_one',JSON.stringify({status: "complete",time: gameTime, code: discountCode, start:discountStart,end:discountEnd,collection:discountCollection}),'json');
      } else{
        var params = {customer_id: " ",namespace: 'customer',key:'game_one',value:JSON.stringify({status: "complete",time: gameTime, code: discountCode, start:discountStart,end:discountEnd,collection:discountCollection}),valueType:'json'};
        document.cookie = "gameParams="+JSON.stringify(params)+"; path=/; max-age=300; secure; samesite=strict";
        setTimeout(()=>{window.location.href = "/account/login"},500);
      }        
    };
    aButtonPressed = false; //clearing this value
  };
  
});

function exitSeq(text) {
  let fText = text.split("...")[0],
      eCount = 0,
      totalCount = 0;
  let ellipser = setInterval(()=>{
    if (eCount < 3) {
      fText = fText+".";
      eCount++; 
    } else{
      eCount = 0;
      fText = fText.split("...")[0];
    };
    let newText = new ex.Text({text: fText,font: spriteFont,height: 16,lineHeight: 32,maxWidth:272});
    dialog.graphics.use(newText);
    totalCount++;
    if (totalCount > 30) {
      $("#mobileButtons").prepend("<p class='error-message'>error: there was an error fetching ur reward. please email info@hardcopyhardcopy.com</p>")
      clearInterval(ellipser);
    };
  },500);
}


//BUILD MAP
class Block extends ex.Actor {
  constructor(x, y, w, h) {
    super({
      width: w,
      height: h,
      pos: new ex.Vector(x,y),
      anchor: ANCHOR_TOP_LEFT,
      collider: ex.Shape.Box(w, h, ex.Vector.Zero),
      collisionType: ex.CollisionType.Fixed,
      color: ex.Color.Green,
    });
    this.graphics.opacity = 0;
  }
}

class Abyss extends ex.Actor {
  constructor(x, y, w, h) {
    super({
      width: w,
      height: h,
      pos: new ex.Vector(x,y),
      anchor: ANCHOR_TOP_LEFT,
      collider: ex.Shape.Box(w, h, ex.Vector.Zero),
      collisionType: ex.CollisionType.Passive,
      color: ex.Color.Red,
    });
    this.graphics.opacity = 0.0;
  }
  onInitialize(engine){
    this.addTag("ABYSS");
  }
}

class SafeZone extends ex.Actor {
  constructor(x, y, w, h) {
    super({
      width: w,
      height: h,
      pos: new ex.Vector(x,y),
      anchor: ANCHOR_TOP_LEFT,
      collider: ex.Shape.Box(w, h, ex.Vector.Zero),
      collisionType: ex.CollisionType.Passive,
      color: ex.Color.Blue,
    });
    this.graphics.opacity = 0.0;
  }
  onInitialize(engine){
    this.addTag("SAFEZONE");
  }
}

const mapSprite = Images.mapImage.toSprite();
class Map extends ex.Actor {
  constructor(x, y) {
    super({
      x: x,
      y: y,
      width: 320,
      height: 288,
      anchor: ANCHOR_TOP_LEFT
    });
    this.graphics.use(mapSprite);
    this.tileWidth = 16;
    this.tileHeight = 16;
  }
  onInitialize(engine) {
    [
      // SHORT BORDERS
      { x: 0, y: 0, w: 16, h: 256 },
      { x: 0, y: 240, w: 256, h: 16 },
      { x: 240, y: 0, w: 16, h: 96 },
      { x: 240, y: 160, w: 16, h: 96 },
        //q2
      { x: 544, y: 32, w: 96, h: 16 },
      { x: 512, y: 112, w: 64, h: 16 },
      { x: 608, y: 112, w: 32, h: 16 },
      { x: 512, y: 64, w: 16, h: 48 },
      { x: 624, y: 48, w: 16, h: 64 },
        //q3
      { x: 384, y: 320, w: 16, h: 256 },
      { x: 624, y: 320, w: 16, h: 256 },
      { x: 384, y: 320, w: 64, h: 16 },
      { x: 512, y: 320, w: 128, h: 16 },
      { x: 384, y: 560, w: 256, h: 16 },
      // LARGE BLOCKS
      { x: 0, y: 0, w: 32, h: 32 },
      { x: 0, y: 224, w: 32, h: 32 },
      { x: 224, y: 0, w: 32, h: 32 },
      { x: 224, y: 224, w: 32, h: 32 },
      { x: 512, y: 96, w: 32, h: 32 },
      { x: 608, y: 32, w: 32, h: 32 },
      { x: 384, y: 320, w: 32, h: 32 },
      { x: 384, y: 544, w: 32, h: 32 },
      { x: 608, y: 320, w: 32, h: 32 },
      { x: 608, y: 544, w: 32, h: 32 },
    ].forEach(({ x, y, w, h }) => {
      const block = new Block(x, y, w, h);
      engine.add(block);
    });

    // ABYSS
    [
      { x: 256, y: 0, w: 384, h: 32 },
      { x: 256, y: 32, w: 160, h: 64 },
      { x: 256, y: 160, w: 192, h: 160 },
      { x: 352, y: 96, w: 64, h: 32 },
      { x: 448, y: 64, w: 64, h: 128 },
      { x: 512, y: 128, w: 64, h: 64 },
      { x: 480, y: 224, w: 32, h: 32 },
      { x: 512, y: 224, w: 128, h: 96 },
      { x: 608, y: 128, w: 32, h: 96 },
    ].forEach(({ x, y, w, h }) => {
      const abyss = new Abyss(x, y, w, h);
      engine.add(abyss);
    });
    
    // SAFEZONE
    [
      { x: 0, y: 0, w: 256, h: 256 },
      { x: 512, y: 32, w: 128, h: 96 },
      { x: 384, y: 320, w: 256, h: 256 },
    ].forEach(({ x, y, w, h }) => {
      const safezone = new SafeZone(x, y, w, h);
      engine.add(safezone);
    });
    
  };
};

const bgSprite = Images.bgImage.toSprite();
const background = new ex.Actor({
  width: 320,
  height: 288,
  anchor: ANCHOR_TOP_LEFT,
  pos: new ex.Vector(0,0),
});
background.graphics.use(bgSprite);



// START GAME
const oni = new Oni(480,144);
const map = new Map(0,0);
game.add(background);
game.add(map);
game.add(computer);
game.add(hari);
game.add(oni);
game.add(dialogBox);
// SET Z's
background.z = 0;
map.z = 1;
computer.z = 2;
hari.z = 3;
oni.z = 4;
dialogBox.z = 5;


// SAVE TO CUSTOMER ACCOUNT
async function updateCustomerMetafields(customerId, namespace, key, value, valueType) {
    const response = await fetch('https://gamelogs.fly.dev/update-customer-metafields', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            customerId,
            namespace,
            key,
            value,
            valueType,
        }),
    });
    const result = await response.json();
  
    if (result.success) {
      //update disk image
      window.location.href = "/account";  
    } else {
      console.log('failed // please try again');
      // error message
      $("#mobileButtons").prepend("<p class='error-message'>error: there was an error fetching ur reward. please email info@hardcopyhardcopy.com</p>")
    }
    
    
}
await game.start(loader);

//prevent default select behaviour
$(function(){
  $("body").on("click touchstart touchmove touchend", "#gameOneWrapper",function(e){
    e.preventDefault();
    e.stopPropagation();
  });
});
